import axios, { AxiosInstance } from "axios";
import { getGlobalConfigs } from "./configs/globalConfigs";

const apiUrl = getGlobalConfigs().apiUrl;

const instance: AxiosInstance = axios.create({
  baseURL: `${apiUrl}/rest`,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
